<template>
  <v-row>
    <LabelCol v-if="isLabelVisible" :cols="labelCols" :attribute="attribute" />
    <v-col :cols="valueCols" class="pa-0">
      <v-row dense>
        <v-col cols="6">
          <v-text-field
            :readonly="!canEdit"
            :disabled="isCopied"
            v-model.number="from"
            :label="$i18n.t('default.from')"
            outlined
            :rules="rules"
            v-bind="inputProps"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            :readonly="!canEdit"
            :disabled="isCopied"
            v-model.number="to"
            :label="$i18n.t('default.to')"
            outlined
            :rules="rules"
            v-bind="inputProps"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import LabelCol from './LabelCol';

export default {
  components: {
    LabelCol
  },
  model: {
    event: 'input'
  },
  props: {
    attribute: {
      required: true,
      type: Object
    },
    labelCols: {
      default: 4,
      type: Number
    },
    valueCols: {
      default: 8,
      type: Number
    },
    canEdit: {
      required: true,
      type: Boolean
    },
    isCopied: {
      required: false,
      default: false,
      type: Boolean
    },
    loading: {
      default: false,
      type: Boolean
    },
    value: {
      required: true
    },
    inputProps: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isLabelVisible: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  data: () => ({}),
  computed: {
    to: {
      get() {
        return this.value && this.value.to ? this.value.to : '';
      },
      set(nV) {
        this.$emit('input', {
          to: nV,
          from: this.from
        });
      }
    },
    from: {
      get() {
        return this.value && this.value.from ? this.value.from : '';
      },
      set(nV) {
        this.$emit('input', {
          to: this.to,
          from: nV
        });
      }
    },
    rules() {
      const rules = [];
      if (this.attribute.required) {
        rules.push(value => !!value || this.$i18n.t('default.requiredField'));
      }
      return rules;
    }
  }
};
</script>
